import { useWebSocketContext } from 'presentation/app/hooks/WebSocketProvider';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

import { useAuth } from '../../../../presentation/app/hooks/useAuth';

const ProfileDropdown = () => {
  const { currentUser, logout } = useAuth();
  const { socket } = useWebSocketContext();
  const navigate = useNavigate();

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            {currentUser?.photo ? (
              <img
                style={{ background: '#144c5b' }}
                className="rounded-circle header-profile-user"
                src={currentUser?.photo}
                alt="Avatar"
              />
            ) : (
              <div
                style={{ background: '#144c5b' }}
                className="rounded-circle header-profile-user d-flex justify-content-center align-items-center"
              >
                <i className="text-white ri-user-3-line"></i>
              </div>
            )}
            <span className="text-start ms-xl-2">
              <span className="text-white d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {' '}
                {currentUser?.firstName || 'Admin'}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem
            onClick={() => {
              navigate('/perfil');
            }}
          >
            <i className="text-muted ri-user-line me-1 fs-16"></i>
            <span className="align-middle" data-key="t-logout">
              Meu Perfil
            </span>
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              logout();
              if (socket) {
                socket.disconnect();
              }
            }}
          >
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{' '}
            <span className="align-middle" data-key="t-logout">
              Sair
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
